// React
import React from 'react';
import classNames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';
// Styles
import useStyles from './EmptyRtAvatar.styles';

const EmptyRtAvatar = ({ classes }) => {
  const componentClasses = useStyles();
  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <CircularProgress
        classes={{ colorPrimary: componentClasses.colorPrimary }}
      />
    </div>
  );
};

EmptyRtAvatar.defaultProps = {
  classes: {},
};

export default EmptyRtAvatar;
